<template>
  <div>
    <div
      class="input-container"
      :class="{disabled: disabled}">
      <div
        class="top-label sm-text"
        v-if="label">
        {{ label }}
      </div>

      <div class="input-wrapper">
        <div
          class="input-group"
          :class="{'error-border': errorMessage}">
          <textarea
            :placeholder="placeholder"
            :disabled="disabled"
            :value="value"
            :rows="rows"
            @input="$emit('input', $event.target.value)"
            class="uih6"
            ref="textareaElement" />
        </div>
      </div>
    </div>
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SixTextarea",
  props: {
    value: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "",
    },

    label: {
      type: String,
      default: "",
    },

    errorMessage: {
      type: String,
      default: "",
    },

    rows: {
      type: [String, Number],
      default: 4,
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: var(--font-family);
}

.input-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-group {
  display: flex;
  width: 100%;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.top-label {
  margin: 4px 0;
}

textarea {
  flex: 1;
  padding: 10px 12px;
  border-radius: 4px;
  border: none;
  background: #fff;
  font-family: var(--font-family);
  line-height: 1.5;
  resize: vertical;
  min-height: 80px;
}

textarea::placeholder {
  color: var(--color-deactive-text);
  font-style: normal;
  font-weight: 300;
}

textarea:disabled {
  color: var(--color-deactive-text);
  cursor: not-allowed;
  background: #e9ecef;
}

.error-message {
  color: var(--color-danger);
  font-size: 14px;
  margin-top: 4px;
}

.error-border {
  border: 1px solid var(--color-danger);
}
</style>
